var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_38582",
    "data-name": "Group 38582",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.75,
    height: 16.75,
    viewBox: "0 0 16.75 16.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27964",
    "data-name": "Path 27964",
    d: "M15.656,4.182a.973.973,0,0,0-1.3.35.86.86,0,0,0,.372,1.226,6.277,6.277,0,0,1,3.257,5.254,6.291,6.291,0,0,1-6.514,6.129,6.291,6.291,0,0,1-6.514-6.129A6.3,6.3,0,0,1,8.211,5.671.822.822,0,0,0,8.49,4.533a.973.973,0,0,0-1.3-.35A7.8,7.8,0,0,0,3,11.012a8.105,8.105,0,0,0,8.375,7.881,8.105,8.105,0,0,0,8.375-7.881A8,8,0,0,0,15.656,4.182Z",
    transform: "translate(-3 -2.143)",
    fill: "#f16667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27965",
    "data-name": "Path 27965",
    d: "M11.931,12.236a.879.879,0,0,0,.931-.931V2.931a.931.931,0,1,0-1.861,0v8.375A.879.879,0,0,0,11.931,12.236Z",
    transform: "translate(-3.556 -2)",
    fill: "#f16667"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.1283d53fba9f3df734d6578fbdc13bdf.svg";
export { ForwardRef as ReactComponent };